import React, { useState } from 'react'
import { Stack, Button, Modal } from '@shopify/polaris'

const ContextualSaveBarComponent = (props) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false)
  const primaryButtonActions = props.onSaveAction2 ? [{
    content: 'Save and Continue Editing',
    onAction: props.onSaveAction2
  }] : []
  return (
    <div className='Polaris-Frame__ContextualSaveBar'>
      <div className="Polaris-Frame-ContextualSaveBar">
        <div className="Polaris-Frame-ContextualSaveBar__Contents Polaris-Frame-ContextualSaveBar--fullWidth">
          <h2 className="Polaris-Frame-ContextualSaveBar__Message">Unsaved changes</h2>
          <div className="Polaris-Frame-ContextualSaveBar__ActionContainer">
            <Stack spacing="tight" wrap={false}>
              {props.onDiscardAction && <Button onClick={() => {
                setConfirmationModalOpen(true)
              }}>Discard</Button>}
              {props.onSaveAction &&
                <Button
                  onClick={props.onSaveAction}
                  primary
                  connectedDisclosure={
                    primaryButtonActions.length > 0 ? {
                      accessibilityLabel: 'Other save actions',
                      actions: primaryButtonActions
                    } : false
                  }
                >
                  Save
                </Button>
              }
            </Stack>
          </div>
        </div>
      </div>
      <Modal
        open={confirmationModalOpen}
        onClose={() => {
          setConfirmationModalOpen(false)
        }}
        title="Confirm Discard Changes"
        primaryAction={{
          content: 'Discard Changes',
          destructive: true,
          onAction: () => {
            props.onDiscardAction()
            setConfirmationModalOpen(false)
          }
        }}
        secondaryActions={[
          {
            content: 'Cancel',
            onAction: () => {
              setConfirmationModalOpen(false)
            },
          },
        ]}
      />
    </div>
  )
}

export default ContextualSaveBarComponent
